define('views/modules/goal/edit/goal-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // services
    'services/events/goal-events',
    'services/events/calendar-events',
    'services/api',
    //models
    'models/calendar/item/personal-data',
    'models/calendar/personal-data/personal-data-type',
    // views
    'src/views/form-view',
    'views/parts/info-section',
    'views/modules/goal/edit/types/main-goal',
    'views/modules/goal/edit/types/custom-goal',
    'views/modules/goal/edit/types/duration-goal',
    'views/modules/feedback/modal/feedback-modal-mixin',
    // templates
    'text!templates/modules/goal/edit/goal-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // services
    GoalEvents,
    CalendarEvents,
    API,
    //models
    MPersonalData,
    MPersonalDataType,
    // views
    VForm,
    VInfoSection,
    VMainGoal,
    VCustomGoal,
    VDurationGoal,
    VFeedbackModalMixin,
    // templates
    TGoalEditForm
) {

    var TYPES = {
        minutes: VDurationGoal,
        distance: VMainGoal,
        custom: VCustomGoal
    };

    var VGoalEditForm = VForm.extend({
        template: TGoalEditForm,

        regions: {
            form: '.form-content'
        },

        initialize: function(opt) {
            opt = opt || {};

            this.isNewCustomGoal = false;

            var profile = this.profile = opt.profile,
                model = this.model,
                view = this.view = {
                    info: new VInfoSection({
                        title: "Details Form",
                        content: this.template,
                    }),
                };

            this.listenTo(model, {
                'change': this.onModelChange,
                'change:type': this.onTypeChange,
                'apply': this.applyModel,
            });

            this.selectedType = model.getType();
        },

        render: function() {

            this.assign(this.view.info, this.$el); // must be first

            this.generateZones();
            var zone = this.zone,
                view = this.view;

            this.setContentView()
                .setDefaultValues();

            this.isNewCustomGoal = this.model.isNew();

            return this;
        },

        setContentView: function(selectedType) {
            var model = this.model,
                type = selectedType || model.getType(),
                viewObj = this.view,
                view = viewObj[type],
                content = viewObj.content;

            if (!view) {
                var TypeView = this.getTypeView();
                view = this.view[type] = new TypeView({
                    model: model,
                    profile: this.profile,
                });
            }

            if (content !== view) {
                if (content) content.disable();
                content = viewObj.content = view;
                this.zone.$form.empty().append(view.render().el);
            } else {
                view.render();
            }

            return this;
        },

        getTypeView: function() {
            return TYPES[this.model.getType()];
        },

        setDefaultValues: function() {
            var model = this.model;

            if (model.isNew()) {
                model.set('start', this.profile.get(model.getCalendarItemAttr()));
                this.applyModel();
            }

            return this;
        },

        checkIfNewCalendarEntryIsNeeded: function(lastCustomDataEntry) {

          var MCustomGoal = this.view[this.selectedType].model;
          var customGoalcomputeType = this.view[this.selectedType].customGoalComputeType === 1 || this.view[this.selectedType].customGoalComputeType === true ? 'sumEntry' : 'lastEntry';
          var bNeedNewCalendarEntry = false;

          //If a calendar entry exist for this custom data goal and last entry is not today
          if (lastCustomDataEntry) {
              if (lastCustomDataEntry.date !== moment().format('YYYY-MM-DD'))
                bNeedNewCalendarEntry = true;
          } else {
              bNeedNewCalendarEntry = true;
          }

          if (bNeedNewCalendarEntry) {
              var newCustomDataEntry = new MPersonalData();
              newCustomDataEntry.set('date', MCustomGoal.get('startDate'));
              newCustomDataEntry.set('done', true);
              newCustomDataEntry.set('type', 'custom_data');
              newCustomDataEntry.set('unit', MCustomGoal.getUserUnit(MCustomGoal.get('customData_unit')));
              newCustomDataEntry.set('value', MCustomGoal.get('startValue').value);
              newCustomDataEntry.set('customData', MCustomGoal.get('customData_id'));
              newCustomDataEntry.set('user', this.profile.get('_id'));
              newCustomDataEntry.save();
          }
        },

        ////////////
        // events //
        ////////////
        onTypeChange: function(model, value) {
            var selectedType = this.selectedType,
                isSameType = selectedType === value;
            this.selectedType = value;

            if (!isSameType) this.setDefaultValues();
            if (this.zone) this.setContentView(value);
        },

        onSubmit: function() {
            var profile = this.profile,
                model = this.model;
            if (model.isNew()) {

                var relatedUnits = {
                    distance: profile.get('distanceUnit'),
                };

                if (model.isCustom()) {
                    relatedUnits.custom = this.getCustomUnit(model, this.view['custom'].SelectedCustomDataType.get('unit'));
                }

                model.setRelatedTypeUnit(relatedUnits);

                if (model.getType() === 'custom') {
                  var isSumGoal = this.view[this.selectedType].SelectedCustomDataType.get('sumEntry');
                  model.set('sumGoal', isSumGoal);
                  if (isSumGoal)
                    model.set('startValue', '0');
                }
                model.setUser(this.profile);
            }
        },

        getCustomUnit: function(model, unit) {
            if (model.isConvertible()) {
                return (new MPersonalDataType({ _id: model.get('customData_id'), unit: unit })).getUserUnit();
            }

            return unit;
        },

        onSuccess: function() {
            //If new Custom Goal and not type SumEntry, maybe a new calendar entry is needed for today
            var newItemCreatedForToday = false;
            if (this.selectedType === 'custom' && this.isNewCustomGoal && !this.view[this.selectedType].SelectedCustomDataType.get("sumEntry")) {
              this.isNewCustomGoal = false;
              this.checkIfNewCalendarEntryIsNeeded(this.view[this.selectedType].lastCustomDataEntry);
            }

            GoalEvents.goalUpdate(this.model.clone());
        },

        onModelChange: function(model) {
            this.trigger('model:change', this.isDirty());
        },

    });

    return VGoalEditForm;
});

